<div class="container-fluid h-100 login-form-wrapper">
  <div class="card login-card">
    <div class="d-flex flex-column card-body p-4 align-items-center justify-content-center">
      
      <!-- Loading State -->
      <div *ngIf="isLoading" class="form-content text-center">
        <h1>Verifying Your Email</h1>
        <p>Please wait while we verify your email address...</p>
        <mat-spinner class="mx-auto mt-3"></mat-spinner>
      </div>

      <!-- Success State -->
      <div *ngIf="!isLoading && isSuccess" class="form-content text-center">
        <h1>Email Verified!</h1>
        <p>Your email has been successfully verified. You can now login to your account.</p>
        <mat-icon class="success-icon" color="primary">check_circle</mat-icon>
      </div>

      <!-- Error State -->
      <div *ngIf="!isLoading && !isSuccess" class="form-content text-center">
        <h1>Verification Failed</h1>
        <p>{{ errorMessage }}</p>
        <mat-icon class="error-icon" color="warn">error</mat-icon>
      </div>

    </div>

    <a routerLink="/" mat-button color="primary">
      <mat-icon aria-hidden="false" aria-label="Back to login">keyboard_arrow_left</mat-icon>
      <span>Back to login</span>
    </a>
  </div>
</div>
